/**
 * @file getSetting.ts
 * Exports a method for returning an item from the source settings.
 */
import { pathOr } from 'ramda';
import type { AppState } from '../types';

/**
 * Helper method that returns one of the settings from the app data.
 *
 * Currently app settings are stored in the appState data. In the future this
 * data may come from an external API. Example source data:
 *
 * {
 *   'settings': {
 *     'title': 'Product Selector Tool',
 *     'tagline': 'Complete the assessment with these simple questions.'
 *   },
 *   ...
 * }
 *
 * @param {AppState} appState
 *   The application state store.
 * @param {string} id
 *   The name of a settings property.
 * @returns {string}
 *   Setting value, or undefined.
 */
export default (appState: AppState, id: string): string =>
  pathOr('', ['appData', 'settings', id], appState);
